export const LOGOUT_ACTION = 'LOGOUT_ACTION';

export default function logout() {
  // Clear local storage that contains user data
  window.localStorage.clear();

  return {
    type: LOGOUT_ACTION,
  };
}
